import { route, tag, type PageTour } from '../pageTour';

export const cameraImportTour: PageTour = {
  id: 'page-camera-import',
  version: 1,
  title: 'Bulk camera upload',
  summary: 'Add many cameras at once from a spreadsheet.',
  match: route('/cameras/import'),
  steps: [
    {
      target: tag('camera-import-template'),
      title: 'Start from the template',
      description: 'Download a ready-made file with the right column headers, then fill in one camera per row.',
      side: 'left',
    },
    {
      target: tag('camera-import-columns'),
      title: 'What each column means',
      description: 'Check which columns are required and what to put in each. Column order does not matter.',
      side: 'top',
    },
    {
      target: tag('camera-import-dropzone'),
      title: 'Choose your file',
      description: 'Pick or drop a CSV or Excel file. You will see a preview of its rows before anything is imported.',
      side: 'top',
    },
    {
      target: tag('camera-import-submit'),
      title: 'Import',
      description: 'When the preview looks right, import the cameras into the selected site. Cameras that already exist are skipped, never duplicated.',
      side: 'top',
      permission: 'cameras.add',
    },
  ],
};
